import React from "react";

const Header = () => {
  // Set the profile image and user name based on userType
  const userProfileImage =
    !localStorage.getItem("userImg") ||
    localStorage.getItem("userImg") == undefined ||
    localStorage.getItem("userImg") == "null"
      ? "/assets/images/faces/face1.png"
      : localStorage.getItem("userImg");
  const userRole =
    localStorage.getItem("role") == "Insegnante" ? "Ins." : "Adm.";
  const userName = localStorage.getItem("userName") || "User";

  const handleLogout = () => {
    localStorage.clear();
    if (userRole == "Adm.") {
      window.location.href = "/login/admin";
    } else {
      window.location.href = "/login";
    }
  };

  return (
    <header className="app-header">
      {/* Start::main-header-container */}
      <div className="main-header-container container-fluid">
        {/* Start::header-content-left */}
        <div className="header-content-left">
          {/* Logo */}
          <div className="header-element">
            <div className="horizontal-logo">
              <a href="/" className="header-logo">
                <img
                  src="/assets/images/brand-logos/desktop-logo.png"
                  alt="logo"
                  className="desktop-logo"
                />
                <img
                  src="/assets/images/brand-logos/toggle-logo.png"
                  alt="logo"
                  className="toggle-logo"
                />
                <img
                  src="/assets/images/brand-logos/desktop-dark.png"
                  alt="logo"
                  className="desktop-dark"
                />
                <img
                  src="/assets/images/brand-logos/toggle-dark.png"
                  alt="logo"
                  className="toggle-dark"
                />
              </a>
            </div>
          </div>

          {/* Toggler */}
          <div className="header-element mx-lg-0 mx-2">
            <a
              aria-label="Hide Sidebar"
              className="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
              data-bs-toggle="sidebar"
              href="#"
              onClick={(e) => e.preventDefault()}
            >
              <span></span>
            </a>
          </div>
        </div>
        {/* End::header-content-left */}

        {/* Start::header-content-right */}
        <ul className="header-content-right">
          {/* Start:: User */}
          <li className="header-element">
            {/* Start::header-link|dropdown-toggle */}
            <a
              href="#"
              className="header-link dropdown-toggle"
              id="mainHeaderProfile"
              data-bs-toggle="dropdown"
              data-bs-auto-close="outside"
              aria-expanded="true"
            >
              <div className="d-flex align-items-center">
                <div className="me-sm-2 me-0">
                  <img
                    src={userProfileImage}
                    className="avatar avatar-sm avatar-rounded"
                    alt="User Avatar"
                  />
                </div>
                <div className="d-xl-block d-none lh-1">
                  <span className="fw-medium lh-1">
                    {userRole + " " + userName}
                  </span>
                </div>
              </div>
            </a>
            {/* End::header-link|dropdown-toggle */}
            <ul
              className="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end"
              aria-labelledby="mainHeaderProfile"
            >
              <li>
                <a
                  className="dropdown-item d-flex align-items-center"
                  href="/profile"
                >
                  <i className="bi bi-person fs-18 me-2 op-7"></i>Profilo
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleLogout}
                  href="#"
                >
                  <i className="bi bi-box-arrow-right fs-18 me-2 op-7"></i>Log
                  Out
                </a>
              </li>
            </ul>
          </li>
          {/* End:: User */}
        </ul>
        {/* End::header-content-right */}
      </div>
      {/* End::main-header-container */}
    </header>
  );
};

export default Header;
